/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../button/button';
import Remarked from '../../remarked/remarked';
import { isInitialized, pixel } from '../../../../participant/views/participant/facebook-pixel';

import {
  RESULT__ITEM_SHAPE,
  SURVEYS__SHAPE_ITEM,
  SURVEY_CLIENT__SHAPE_ITEM,
} from '../../../redux/constants';
import { finalizerCss } from './finalizer-page.css';
import { withBrandingFeature } from '../../../../participant/util';
import { BottomNav } from '../bottom-nav/bottom-nav';

const rewardsAvailable = (rewardStatus) => ['empty', 'low', 'high'].indexOf(rewardStatus) !== -1;

export const SuccessMessage = ({ reward }) => {
  const { t } = useTranslation();
  const shouldTrack = isInitialized();

  useEffect(() => {
    if (shouldTrack) {
      pixel.track('track', 'SubmitApplication');
    }
  }, [shouldTrack]);

  if (!reward) {
    return t('pages.yourResponseIsSaved');
  }

  return get(reward, 'success', false) ? (
    <Fragment className="finalizer__lead">
      <h2 className="finalizer__congratulations">{t('pages.congratulations')}</h2>
      <hr className="finalizer__rule" />
      <p>{t('pages.rewardCodeSent', { brand: withBrandingFeature('We', 'Beag.ly') })}</p>
      <div className="finalizer__email">{get(reward, 'email')}</div>
    </Fragment>
  ) : (
    <Remarked>{get(reward, 'reason')}</Remarked>
  );
};

export function FinalizerPage(props) {
  const { finalise, finaliserBusy, result, survey, surveyClient } = props;
  const { t } = useTranslation();

  return (
    <div css={finalizerCss}>
      {result.state === 'finished' ? (
        <div className="finalizer__lead">
          <SuccessMessage reward={surveyClient.reward} />
        </div>
      ) : (
        <Fragment>
          <div className="finalizer__lead">
            <p>{survey.thankYouCopy}</p>
            {rewardsAvailable(surveyClient.rewardStatus) && (
              <p>{t('pages.clickFinishToGetReward')}</p>
            )}
          </div>

          <Button
            className="btn-lg"
            onClick={() => finalise(surveyClient.token)}
            type="submit"
            showPreloader={finaliserBusy}
          >
            {t('pages.finish')}
          </Button>
        </Fragment>
      )}
      <BottomNav {...props} answersDisabled />
    </div>
  );
}

FinalizerPage.propTypes = {
  finalise: PropTypes.func.isRequired,
  finaliserBusy: PropTypes.bool,
  result: RESULT__ITEM_SHAPE.isRequired,
  survey: SURVEYS__SHAPE_ITEM.isRequired,
  surveyClient: SURVEY_CLIENT__SHAPE_ITEM.isRequired,
};

FinalizerPage.defaultProps = {
  finaliserBusy: false,
};
